import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import CustomPdf from '../views/CustomPdf.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/pdf',
    name: 'pdf',
    component: CustomPdf
  }
]

const router = new VueRouter({
  routes
})

export default router
